import { render, staticRenderFns } from "./StatusChangeHistory.vue?vue&type=template&id=77337fc0&"
import script from "./StatusChangeHistory.vue?vue&type=script&lang=js&"
export * from "./StatusChangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList})
